/**
 * @file FontsBackLink.tsx
 * @description Ссылка «← К элементу «…»» во вкладке «Шрифты» (phase19.16;
 * SB10, дополнение 2026-10-11; uiux-fonts-usage §4): возврат к элементу, из
 * подсказки которого пришли (`?back=…&backLabel=…`). Стоит в общей липкой
 * строке панели (`SettingsGroups stickyTop`, SB122 §2) — после прокрутки к
 * роли возврат остаётся виден; высота ссылки-перехода 48 / 44 (`JUMP_LINK_CLASS`).
 */

import { ArrowLeft } from "lucide-react";
import { Link } from "react-router";

import { cn } from "@/lib/utils";
import { JUMP_LINK_CLASS } from "../../ui/jump-link";
import { backLinkText, type FontsTabBack } from "../../../lib/site-view/fonts-tab-params";

export function FontsBackLink({ back }: { back: FontsTabBack }) {
  return (
    <div data-testid="fonts-back-bar">
      <Link
        to={back.href}
        className={cn(JUMP_LINK_CLASS, "type-body flex gap-2 py-2")}
      >
        <ArrowLeft aria-hidden className="size-4 shrink-0" />
        <span className="min-w-0 break-words">{backLinkText(back.label)}</span>
      </Link>
    </div>
  );
}
